import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input, Table } from 'reactstrap';
import { noop } from 'lib/noop';

import { HORIZONTAL_MODE, VERTICAL_MODE } from 'app/CanvasWidgets/const';
import styles from './TableWidgetModal.css';

/**
 * Component for render dynamic table with data
 * @returns {React.Component} - table component
 */
const DynamicTable = ({ rows, mode, handleChange, handleFocus, activeTable, tablesNames }) => {
  const getValue = item => {
    const currentTable = activeTable || tablesNames[0] || Object.keys(item)[0];
    const result = currentTable ? item[currentTable] : '';
    return !result && parseInt(result, 10) !== 0 ? '' : result;
  };

  return (
    <Table size="lg" borderless>
      <tbody>
        {rows.map((row, i) => {
          const { multiline, bold } = row.rowOptions;
          const inputType = multiline ? 'textarea' : 'text';
          return (
            <tr
              className={classnames([
                mode === HORIZONTAL_MODE ? styles.horizontalMode : styles.verticalMode,
                styles.inputWrapper
              ])}
              key={`tr-${i}`}
            >
              {row.rowData.map((cell = {}, j) => {
                // eslint-disable-next-line react/no-array-index-key
                return (
                  <td className={styles.tableCell} key={`tr-${i}-td-${j}`}>
                    <Input
                      className={classnames(
                        { [styles.title]: mode === VERTICAL_MODE && j === 0 },
                        { [styles.bold]: bold }
                      )}
                      onChange={handleChange(i, j)}
                      onFocus={handleFocus(i, j)}
                      type={inputType}
                      value={getValue(cell)}
                    />
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
DynamicTable.defaultProps = {
  rows: [],
  handleChange: noop,
  handleFocus: noop,
  tablesNames: []
};

DynamicTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      rowData: PropTypes.arrayOf(PropTypes.object),
      rowOptions: PropTypes.object
    })
  ),
  mode: PropTypes.string.isRequired,
  activeTable: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  handleFocus: PropTypes.func,
  tablesNames: PropTypes.arrayOf(PropTypes.string)
};

export default DynamicTable;
